module.exports = __webpack_public_path__ + "img/profile-setting.95f09bcb.png";